module.exports = __webpack_public_path__ + "img/jn.58f8b267.png";